import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import PolarQuestion from "@/components/job/PolarQuestion";

export type StrainsChecksPolar = {
  do_you_want_to_design_for_continous_long_term_strains: PolarYesNoUndefined;
};
type StrainsChecksProps = {
  onHandleYesNo: (payload: { value: PolarYesNoUndefined; key: keyof StrainsChecksPolar }) => void;
  polarQuestions: StrainsChecksPolar;
};
export default function StrainsChecks({ onHandleYesNo, polarQuestions }: StrainsChecksProps) {
  return (
    <>
      <PolarQuestion
        shouldRender
        question="Do you want to design for continous long term strains?"
        onNoClick={() => onHandleYesNo({ value: "no", key: "do_you_want_to_design_for_continous_long_term_strains" })}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "do_you_want_to_design_for_continous_long_term_strains" });
        }}
        selection={polarQuestions.do_you_want_to_design_for_continous_long_term_strains}
      />
    </>
  );
}
